import axios from "axios";


export default function callPostApiWithoutConfigURl(urlStr, headers, data) {

    return axios.post(urlStr, data, {
        // withCredentials: true,
        // credentials: "include",
        headers: headers,
    }).then(response => {
        return response.data;
    }).catch(error => {
        if (error && error.response && error.response.status) {
            return error.response.status;
        }
    });
}

